angular.module('storage.driver', [])
  .factory('store', ['sessionDriver', 'localDriver', 'memoryDriver', function (sessionDriver, localDriver, memoryDriver) {

    var available = [sessionDriver, localDriver, memoryDriver];

    var active = {
      volatile: [],
      persistent: []
    };

    function init() {
      available.forEach(function (driver) {
        if (driver.test()) {
          active[driver.getType()].push(driver);
        }
      });
    }

    function Store(type) {
      this._default = type || 'volatile';
      init();
    }

    Store.prototype.default = function () {
      return active[this._default][0];
    };

    Store.prototype.get = function (key, def) {
      return this.default().get(key, def);
    };

    Store.prototype.set = function (key, val) {
      return this.default().set(key, val);
    };

    Store.prototype.driver = function (type) {
      return active[type][0];
    };
    return Store;

  }]);
angular.module('storage', ['storage.driver']);
angular.module('storage')
  .provider('storage', function () {

    this.types = [
      'volatile', 'persistent'
    ];

    this.default = 'volatile';

    this.setDefault = function (type) {
      if (!type in this.types) {
        throw new Error('Not a valid storage type', type);
      }

      this.default = type;
    };

    this.$get = function () {
      var store = angular.injector(['storage.driver']).get('store');
      return new store(this.default || 'volatile');
    };
  });
angular.module('storage.driver')
  .factory('localDriver', ['webDriver', function (webDriver) {
    var driver = new webDriver();
    driver.setType('persistent');
    try {
      driver.setStore(window.localStorage);
    } catch (e) {
      this.available = false;
    }
    return driver;
  }]);
angular.module('storage.driver')
  .factory('memoryDriver', function () {

    function Driver() {
      this.type = 'volatile';
      this.available = null;
      this.store = {};
    }

    Driver.prototype.test = function () {
      return true;
    };

    Driver.prototype.get = function (key, def) {
      return this.store[key] || def;
    };

    Driver.prototype.set = function (key, val) {
      this.store[key] = val;
    };

    Driver.prototype.getType = function () {
      return this.type;
    };

    return new Driver();

  });
angular.module('storage.driver')
  .factory('sessionDriver', ['webDriver', function (webDriver) {

    var driver = new webDriver();
    driver.setType('volatile');
    try {
      driver.setStore(window.sessionStorage);
    } catch (e) {
      this.available = false;
    }
    return driver;

  }]);
angular.module('storage.driver')
  .factory('webDriver', function () {

    function Driver(prefix) {
      this.prefix = 'storage';
      this.type = null;
      this.available = null;
      this.cache = {};
      this.store = null;
    }

    Driver.prototype.setStore = function (store) {
      this.store = store;
      this.loadCache();
    };

    Driver.prototype.setType = function (type) {
      this.type = type;
    };

    Driver.prototype.buildKey = function (key) {
      return [this.prefix, key].join('.');
    };

    Driver.prototype.loadCache = function () {
      try {
        Object.keys(this.store).filter(function (key) {
          return key.indexOf(this.prefix) == 0;
        }.bind(this)).forEach(function (key) {
          this.cache[key.replace(this.prefix + '.', '')] = this.deserialize(this.store.getItem(key));
        }.bind(this));
      } catch (e) {
        console.error('could not load cache', e);
        return {};
      }
    };

    Driver.prototype.serialize = function (data) {
      try {
        return JSON.stringify(data);
      } catch (e) {
        return '';
      }
    };

    Driver.prototype.deserialize = function (string) {
      try {
        return JSON.parse(string);
      } catch (e) {
        return '';
      }
    };

    Driver.prototype.test = function () {

      if (this.available == null) {
        try {
          this.store.setItem('test', 'test');
          this.store.removeItem('test');
          this.available = true;
        } catch (e) {
          this.available = false;
        }
      }

      return this.available;
    };

    Driver.prototype.get = function (key, def) {
      return this.cache[key] || def;
    };

    Driver.prototype.set = function (key, val) {
      this.cache[key] = val;
      setTimeout(function() {
        this.write(key);
      }.bind(this))
    };

    Driver.prototype.getType = function () {
      return this.type;
    };

    Driver.prototype.write = function (key) {
      //TODO: dbounce write operations
      this.store.setItem(this.buildKey(key), this.serialize(this.cache[key]));
    };

    return Driver;

  });